import resolvePromise from '../helper/resolved_promise';
import { CatalogAdsActions } from '../constants/catalog_ads/catalog_ads_actions';
import Dispatcher from '../dispatcher';

function setCatalogAdsAction(ads) {
    Dispatcher.handleCatalogAdsAction({
        type: CatalogAdsActions.SET_ADS,
        payload: ads
    });

    return resolvePromise();
}

function loadingCatalogAdsAction() {
    Dispatcher.handleCatalogAdsAction({
        type: CatalogAdsActions.LOAD_CATALOG_ADS_ACTION
    });

    return resolvePromise();
}

function setCatalogAdsBuyerAssistUrl(url) {
    Dispatcher.handleCatalogAdsAction({
        type: CatalogAdsActions.SET_BUYER_ASSIST_URL,
        payload: url
    });

    return resolvePromise();
}

export {
    setCatalogAdsAction,
    loadingCatalogAdsAction,
    setCatalogAdsBuyerAssistUrl,
};